<template>
  <div class="info-wrap">
    <div class="info-con">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="8" class="dialog-label">推送类别</el-col>
          <el-col :span="16">
            {{ infoData.pushType }}
          </el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="8" class="dialog-label">应用名称</el-col>
          <el-col :span="16">
            {{ infoData.appName }}
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-col :span="8" class="dialog-label">创建人</el-col>
          <el-col :span="16">
            {{ infoData.createName }}
          </el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="8" class="dialog-label">信息标题</el-col>
          <el-col :span="16">
            {{ infoData.title }}
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="line-height: 26px;">
        <el-col :span="24">
          <el-col :span="4" class="dialog-label">信息内容</el-col>
          <el-col :span="20">
            {{ infoData.content }}
          </el-col>
        </el-col>
      </el-row>
    </div>
    <div v-if="infoData.pushType == '单体推送'">
      <el-table
        ref="singleTable"
        :data="tableDataArr"
        tooltip-effect="dark"
        style="width: 100%;"
        size="mini"
        stripe
        height="360px"
      >
        <el-table-column
          type="index"
          align="center"
          label="序号"
          width="55"
        ></el-table-column>
        <el-table-column prop="vin" label="车架号"></el-table-column>
        <el-table-column prop="deviceId" label="设备编号"></el-table-column>
        <el-table-column prop="name" label="车辆绑定人"></el-table-column>
        <el-table-column prop="phone" label="联系电话"></el-table-column>
      </el-table>
    </div>
    <div v-if="infoData.pushType == '分组推送'">
      <p class="dept-title">{{ infoData.parentDeptName }}</p>
      <el-table
        ref="groupTable"
        :data="tableDataArr"
        tooltip-effect="dark"
        style="width: 100%;"
        size="mini"
        stripe
        height="360px"
      >
        <el-table-column
          type="index"
          align="center"
          label="序号"
          width="55"
        ></el-table-column>
        <el-table-column prop="deptName" label="部门名称"></el-table-column>
        <el-table-column prop="name" label="负责人"></el-table-column>
        <el-table-column prop="phone" label="联系电话"></el-table-column>
        <el-table-column prop="email" label="邮箱"></el-table-column>
      </el-table>
    </div>
    <!-- 公用分页 -->
    <el-pagination
      :current-page.sync="currentPage"
      page-size="10"
      layout="total, prev, pager, next, jumper"
      :total="total"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "InfoBox",
  props: {
    infoData: {
      type: Object,
      required: true,
    },
    tableDataArr: {
      type: Array,
      default: () => [],
      required: true,
    },
    total: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      let type = 0
      if (this.infoData.pushType == "单体推送") {
        type = 2
      } else {
        type = 1
      }
      this.$emit("currentChange", this.infoData.pushId, type, val)
    },
  },
}
</script>

<style lang="scss" scoped>
.info-con {
  padding: 0 40px;
  margin-bottom: 10px;
}
.dialog-label {
  font-weight: bold;
}
.info-wrap /deep/ .el-row {
  line-height: 34px;
}
.dept-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
</style>
